import React from 'react';

import { API_getBankGuaranteesEditAndDeleteUrl } from '../../utils/api';

import DeleteModalConstructor from '../Forms/DeleteModalConstructor';

const ConfirmDeleteBankGuarantee = ({ hideModal, data }) => {
  const bankGuaranteeId = data.id.value;

  const deleteModalProps = {
    hideModal,

    DELETE_REQUEST_URL: API_getBankGuaranteesEditAndDeleteUrl(bankGuaranteeId),
    DELETE_STATIC_HINT: 'Вы уверены, что хотите удалить банковскую гарантию',
    DELETE_STATIC_VALUE: data.number.value,
  };

  return <DeleteModalConstructor {...deleteModalProps} />
};

export default ConfirmDeleteBankGuarantee;